import { Extension } from "@tiptap/core";
import { history, redo, undo } from "@tiptap/pm/history";

/**
 * Undo/redo scoped to one inline text-edit session. Wires the ProseMirror
 * history plugin (from the already-bundled `@tiptap/pm`) plus its keymap so
 * Cmd/Ctrl+Z and Cmd/Ctrl+Shift+Z (or Ctrl+Y) undo and redo the edits made
 * since the session opened. Document-level undo (history.ts) picks up once the
 * session commits; the two never overlap because the document keydown handler
 * ignores shortcuts while a session is open.
 */
export const SessionHistory = Extension.create({
  name: "sessionHistory",

  addProseMirrorPlugins() {
    return [history()];
  },

  addKeyboardShortcuts() {
    return {
      "Mod-z": ({ editor }) => undo(editor.state, editor.view.dispatch),
      "Mod-y": ({ editor }) => redo(editor.state, editor.view.dispatch),
      "Mod-Shift-z": ({ editor }) => redo(editor.state, editor.view.dispatch),
    };
  },
});
